import React, { useState, useEffect } from "react";
import { Layout, Button, Divider } from "antd";
import "antd/dist/antd.css";
import "./AdnMenu.css";
import AdnHeader from "../adnHeader/AdnHeader";
import { usePageTitleContext } from "../../../contexts/PageTitleContext";
import { RightOutlined, MenuOutlined } from "@ant-design/icons";

import { X } from "react-feather";

import { useNavigate } from "react-router-dom";
import { userHasRolePermission } from "../../../api/ApiUtils";
import { RolesDescription } from "../GeneralConfigurations";
import AdnMenuComponent from "./AdnMenuComponent";
import { getMenuItems } from "./menuConfig";
import { useTranslation } from "react-i18next";
import { useTenant } from "../../../contexts/TenantContext";

const AdnMenu = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const { Content, Footer, Sider } = Layout;
  const { pageTitle } = usePageTitleContext();
  const { tenantConfig } = useTenant();

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);
    const [selectedKey, setSelectedKey] = useState("");

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    });

    const onCollapse = (value) => {
        setCollapsed(value);
    };

    const userHasRole = (roles) => {
        let hasPermission = userHasRolePermission(
            `${RolesDescription.Admin},${roles}`
        );
        return hasPermission;
    };

    const menuSelected = ({ route, key }) => {
        setSelectedKey(key);
        navigate(route.path);

        if (windowSize[0] < 576) {
            onCollapse(!collapsed);
        }
    };

  const menuItems = getMenuItems(t);

  useEffect(() => {
    const currentItem = menuItems.find(
      (item) => item.route?.path === window.location.pathname
    );
    if (currentItem) {
      setSelectedKey(String(currentItem.key));
    }
  }, [menuItems]);

  const menu = (
    <AdnMenuComponent
      onMenuSelect={menuSelected}
      userHasRole={userHasRole}
      selectedKey={selectedKey}
      menuItems={menuItems}
    />
  );

  return (
    <>
      {windowSize[0] > 576 && (
        <AdnHeader pageTitle={pageTitle} collapsed={collapsed} />
      )}
      <Layout style={{ minHeight: "100vh" }}>
        {windowSize[0] < 576 ? (
          <div style={{ width: "100%" }} className="top-navbar">
            <Button
              className="icon-btn"
              type="primary"
              onClick={() => onCollapse(!collapsed)}
            >
              {collapsed ? <MenuOutlined /> : <X width={16} height={16} />}
            </Button>
            <div
              style={{
                width: "100%",
                height: collapsed ? "0px " : "100%",
                transition: "width 0.3s ease-in-out",
                overflow: "hidden",
              }}
            >
              <Divider />
              {menu}
            </div>
          </div>
        ) : (
          <Sider
            collapsed={collapsed}
            className={collapsed ? "sider-collapsed" : "sider-expanded"}
          >
            <div className="side-elements-container">
              <div
                className={
                  collapsed ? "logo-container-collapsed" : "logo-container"
                }
              >
                <div className={collapsed ? "app-logo-collapsed" : "app-logo"}>
                  {tenantConfig?.logo && (
                    <img
                      src={tenantConfig.logo}
                      alt={tenantConfig.name}
                      className={collapsed ? "logo-collapsed" : "full-logo"}
                      style={{
                        width: collapsed ? "40px" : "auto",
                        height: collapsed ? "40px" : "40px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
                <Button
                  className={collapsed ? "collapse-button" : "collapse-button"}
                  type="text"
                  onClick={() => onCollapse(!collapsed)}
                  icon={
                    <RightOutlined
                      className="collapse-button-icon"
                      style={{
                        transform: collapsed
                          ? "rotate(0deg)"
                          : "rotate(180deg)",
                        transition: "transform 0.2s ease",
                      }}
                    />
                  }
                />
              </div>
              <div style={{ flex: 1, overflow: "auto" }}>{menu}</div>
              <Footer
                style={{
                  padding: "0.5rem",
                  textAlign: "center",
                  backgroundColor: "transparent",
                  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  fontSize: "0.75rem",
                  color: "var(--adndarkblue)",
                  marginTop: "auto",
                }}
              >
                {collapsed
                  ? "MTM v3.0"
                  : "MoOngy Talent Management - Version 3.0.1"}
              </Footer>
            </div>
          </Sider>
        )}

        <Layout className={`site-layout ${collapsed ? "collapsed" : ""}`}>
          <Content style={{ margin: "0 1rem" }}>
            <div className="site-layout-background">{props.children}</div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default AdnMenu;
